export default "__VITE_ASSET__eRYYGGxj__"